import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class DownloadsAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    this.setCssTransition('ease')
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

  // -- 1.2. Interract back
  onLeaveUp() {
    window.dispatchEvent(this.transitionStart)
    this.setCssTransition('ease')
    setTimeout(() => {
      this.resetCssTransition()
    }, this.ANIM_DUR)
  }

  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeaveDown() {
    window.dispatchEvent(this.transitionStart)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.hideVideo()
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

}
